import styled from 'styled-components';
import PropTypes from 'prop-types';

import { flex, grid } from '../../assets/styles/flex-grid';

export const Flex = styled.div`
	${flex};
`;

Flex.propTypes = {
	justify: PropTypes.oneOf(
		['center', 'start', 'end', 'flex-start', 'flex-end', 'left', 'right', 'normal', 'space-between', 'space-around', 'space-evenly', 'stretch']
	),
	align: PropTypes.oneOf(
		['normal', 'stretch', 'center', 'start', 'end', 'flex-start', 'flex-end', 'baseline']
	),
	direction: PropTypes.oneOf(
		[
			'row', 'row-reverse', 'column', 'column-reverse',
		],
	),
};

export const Grid = styled.div`
	${grid};
`;
